export class EmailTemplateContent {
    public locale: string = 'de';
    public subject: string;
    public content: string;
}